import React from "react";
import { Grid, Section, Typography, Divider } from "../../core";
import { MixStyle, media, theme } from "../../styles";
import FabricContractForm from "../../components/FabricContractForm";

import styled from "styled-components";
const { colors } = theme;
const Container = styled.div`
  margin: 50px 0px;
`;
const TittleWraper = styled.div`
  ${MixStyle.flexCenter};
  h1 {
    ${media.minitablet`font-size:36px;`};
  }
  .d-inline--block {
    display: inline-block;
  }
`;
const AddFabricContract = () => {
  return (
    <Container>
      <Grid>
        <Section padding="10px 50px">
          {/* <Typography
              align="right"
              color="#55BD86"
              text={serial_no}
              as="h3"
            /> */}
          <TittleWraper>
            <Typography
              className="d-inline--block"
              align="center"
              as="h1"
              color={colors.darkPink}
              weight="bold"
            >
              Fabric Contract
              <Divider />
            </Typography>
          </TittleWraper>
          <FabricContractForm />
        </Section>
      </Grid>
    </Container>
  );
};

export default AddFabricContract;
